import styled from 'styled-components'

interface StepFourTitleLayoutMobileProps {
  title: string
}

const StepFourTitleLayoutMobile = ({
  title,
}: StepFourTitleLayoutMobileProps) => {
  return (
    <StyledWrapper>
      <strong className="step-title">{title}</strong>
      <p>*제출 후 수정이 불가 합니다.</p>
    </StyledWrapper>
  )
}

export default StepFourTitleLayoutMobile

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;

  > .step-title {
    white-space: pre;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.33;
    letter-spacing: -0.96px;
    text-align: center;
    color: #333;
    font-family: 'GmarketSansMedium';
  }

  > p {
    font-size: 14px;
    font-weight: normal;
    letter-spacing: -0.56px;
    text-align: center;
    color: #333;
  }
`
